import { Modal, Select } from "antd";
import React from "react";

type Props = {
  isVisible: boolean;
  handleCancel: () => void;
};

export const OverviewSettingModal: React.FC<Props> = ({ isVisible, handleCancel }) => {
  return (
    <Modal title="Overview Setting" open={isVisible} onCancel={handleCancel}>
      <Select placeholder="Please select" mode="multiple" style={{ width: "350px" }} showArrow></Select>
    </Modal>
  );
};
